import type { Reference } from './ReferenceMentionNode';

import type { DashboardVideo } from 'js/src/client';
import human_readable_date from 'js/src/libs/readable-date';

export const VIDEO_PAGE_SIZE = 30;

/** The same facts the dashboard tiles show: duration, format, and last edit. */
function describeVideo(video: DashboardVideo): string {
    const parts: string[] = [];

    if (video.duration_seconds) {
        const total = Math.round(video.duration_seconds);
        const minutes = Math.floor(total / 60);
        const seconds = total % 60;
        parts.push(minutes ? `${minutes}m ${seconds}s` : `${seconds}s`);
    }
    if (video.aspect_ratio) {
        parts.push(video.aspect_ratio);
    }
    if (video.last_updated_date) {
        try {
            parts.push(`edited ${human_readable_date(video.last_updated_date)}`);
        } catch {
            // An unparseable date throws; leave the edit date off rather than
            // losing the video's other details.
        }
    }

    return parts.join(' · ');
}

/** Videos still in the script composer have nothing to reference yet. */
export function referencesFromVideos(videos: DashboardVideo[]): Reference[] {
    return videos
        .filter((video) => !video.is_in_script_composer)
        .map((video) => ({
            kind: 'video' as const,
            id: String(video.id),
            name: video.name,
            thumbUrl: video.placeholder_image_url,
            detail: describeVideo(video),
        }));
}
